export default "__VITE_ASSET__CvYAJfTB__"